export const BORDER_WIDTH = 4
